const AUTH0_HOST = String(process.env.REACT_APP_AUTH0_DOMAIN || '')
  .trim()
  .replace(/^https?:\/\//, '')
  .replace(/\/$/, '');

const ALLOWED_PATHS = new Set(['/oauth/token', '/userinfo']);

function headerValue(headers, name) {
  if (!headers) {
    return undefined;
  }
  if (typeof headers.get === 'function') {
    return headers.get(name) || undefined;
  }
  const match = Object.keys(headers).find((key) => key.toLowerCase() === name.toLowerCase());
  return match ? headers[match] : undefined;
}

async function bodyText(body) {
  if (body == null) {
    return undefined;
  }
  if (typeof body === 'string') {
    return body;
  }
  return new Response(body).text();
}

// Edge and Firefox tracking protection block the page from calling Auth0
// directly. The browser talks only to this app; the API calls Auth0.
export function installAuth0FetchProxy() {
  if (!AUTH0_HOST || window.__vivosolAuth0FetchProxy) {
    return;
  }
  window.__vivosolAuth0FetchProxy = true;

  const originalFetch = window.fetch.bind(window);
  window.fetch = async (input, init = {}) => {
    const rawUrl = typeof input === 'string'
      ? input
      : input instanceof URL
        ? input.href
        : input?.url;
    let parsed;
    try {
      parsed = new URL(rawUrl, window.location.origin);
    } catch {
      return originalFetch(input, init);
    }

    if (parsed.host !== AUTH0_HOST || !ALLOWED_PATHS.has(parsed.pathname)) {
      return originalFetch(input, init);
    }

    const requestHeaders = init.headers || (input instanceof Request ? input.headers : undefined);
    const method = String(init.method || (input instanceof Request ? input.method : 'GET')).toUpperCase();
    const response = await originalFetch('/api/auth/auth0-fetch', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        path: `${parsed.pathname}${parsed.search}`,
        method,
        body: await bodyText(init.body),
        contentType: headerValue(requestHeaders, 'content-type'),
        authorization: headerValue(requestHeaders, 'authorization'),
      }),
    });

    return response;
  };
}

installAuth0FetchProxy();
